var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelfRegistration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.259,
    height: 20.258,
    viewBox: "0 0 20.259 20.258",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_538",
    "data-name": "Union 538",
    d: "M14604.514-17453.744a.784.784,0,0,1-.553-.232.773.773,0,0,1-.232-.637l.276-2.666a1.39,1.39,0,0,1,.412-.865l5.763-5.77a1.44,1.44,0,0,1,.921-.334,1.424,1.424,0,0,1,.974.387l.009.008,1.754,1.75a1.382,1.382,0,0,1,.044,1.947v0l-5.758,5.754a1.429,1.429,0,0,1-.864.408l-2.675.246Zm1.018-3.348-.149,1.676,1.68-.154,3.442-3.434-1.513-1.508Zm4.525-4.48,1.5,1.5,1.057-1.035-1.53-1.521ZM14595-17454a1,1,0,0,1-1-1,8.009,8.009,0,0,1,8-8,7.921,7.921,0,0,1,2.245.324,7.367,7.367,0,0,0-1.763,1.7c-.162-.014-.32-.018-.482-.018a5.97,5.97,0,0,0-5.916,4.994h4.929a7.5,7.5,0,0,0,.413,2Zm2-15a5.006,5.006,0,0,1,5-5,5.009,5.009,0,0,1,5,5,5.01,5.01,0,0,1-5,5A5.007,5.007,0,0,1,14597-17469Zm2,0a3,3,0,0,0,3,3,3,3,0,0,0,3-3,3,3,0,0,0-3-3A3.005,3.005,0,0,0,14599-17469Z",
    transform: "translate(-14594.002 17474.002)",
    fill: "currentColor",
    opacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfRegistration);
export default __webpack_public_path__ + "static/media/SelfRegistration.6500a4e10a9d993904ab23dfbf43c209.svg";
export { ForwardRef as ReactComponent };